import React from "react";

const InvestigationsAll = React.createContext();

export default InvestigationsAll;
